export default {
    x10: '2px',
    x15: '4px',
    x20: '6px',
    x30: '8px',
    x35: '12px',
    x40: '16px',
    x45: '24px',
    x50: '100px',
};
